import { CircleBranding } from 'src/api/circles';
import { BRAND_FONT_OPTIONS } from './brandFonts';

export type BrandPreset = {
  id: string;
  /** Button label in Edit Circle. */
  label: string;
  /** Only circles with this special code are offered the preset. */
  onlyForSpecialCode: string;
  /** Logo shipped with the web app (public/), so leaders need no upload. */
  logoPath: string;
  branding: Omit<CircleBranding, 'logo_url'>;
};

const GT_PRESSURA = BRAND_FONT_OPTIONS.find(
  (option) => option.id === 'gt-pressura'
);

/**
 * Ready-made looks a leader can apply in one click. The OTH look is the one
 * taken from the design tokens of ordtilhandling.no.
 */
export const BRAND_PRESETS: BrandPreset[] = [
  {
    id: 'oth',
    label: 'Use the Ordtilhandling look',
    onlyForSpecialCode: 'OTH',
    logoPath: '/branding/oth-logo-cream.png',
    branding: {
      display_name: 'Ordtilhandling',
      primary_color: '#283449',
      on_primary_color: '#ffe8d4',
      secondary_color: '#ea8603',
      background_color: '#ffe8d4',
      text_color: '#263a30',
      font_family: GT_PRESSURA?.body,
      heading_font_family: GT_PRESSURA?.heading,
      heading_uppercase: true,
      button_shape: 'pill',
      brand_navigation: true,
    },
  },
];

/** The preset offered to a circle with this special code, if any. */
export const brandPresetFor = (
  specialCode?: string | null
): BrandPreset | undefined => {
  const code = specialCode?.trim().toUpperCase();
  return code
    ? BRAND_PRESETS.find((preset) => preset.onlyForSpecialCode === code)
    : undefined;
};

// Logos must be https; a local dev server is not, so it borrows staging's copy
const FALLBACK_LOGO_ORIGIN = 'https://staging.dunbar148.com';

/** The preset as a complete branding object, logo on this app's address. */
export const brandingFromPreset = (
  preset: BrandPreset,
  origin: string
): CircleBranding => ({
  ...preset.branding,
  logo_url: new URL(
    preset.logoPath,
    origin.startsWith('https://') ? origin : FALLBACK_LOGO_ORIGIN
  ).toString(),
});
